export const GET_CUSTOMER_PROFILE_DATA = "GET_CUSTOMER_PROFILE_DATA";
export const GOT_CUSTOMER_PROFILE_DATA = "GOT_CUSTOMER_PROFILE_DATA";
export const SAVE_NEW_CUSTOMER_DATA = "SAVE_NEW_CUSTOMER_DATA";
export const SAVED_NEW_CUSTOMER_DATA = "SAVED_NEW_CUSTOMER_DATA";
export const SAVE_EDITED_CUSTOMER_DATA = "SAVE_EDITED_CUSTOMER_DATA";
export const SAVED_EDITED_CUSTOMER_DATA = "SAVED_EDITED_CUSTOMER_DATA";
export const UPDATED_CUSTOMER_PROFILE_DATA = "UPDATED_CUSTOMER_PROFILE_DATA";
export const SET_IS_LOADING_CUSTOMER_PROFILE =
  "SET_IS_LOADING_CUSTOMER_PROFILE";
export const RESET_CUSTOMER_PROFILE_FORM = "RESET_CUSTOMER_PROFILE_FORM";

export const LIMITED_PERMISSIONS = "LIMITED_PERMISSIONS";

export const UPDATE_CUSTOMER_NOT_YET_SAVED_FLAG =
  "UPDATE_CUSTOMER_NOT_YET_SAVED_FLAG";

export const UPDATED_BOOKING_ONLY_CUSTOMER_PROFILE_DATA =
  "UPDATED_BOOKING_ONLY_CUSTOMER_PROFILE_DATA";

export const UPDATE_SHOULD_SAVE_APPOINTMENT_ONCE_WE_GO_BACK_FROM_CUSTOMER_PROFILE =
  "UPDATE_SHOULD_SAVE_APPOINTMENT_ONCE_WE_GO_BACK_FROM_CUSTOMER_PROFILE";

export const updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile = shouldWeSave => {
  return {
    type: UPDATE_SHOULD_SAVE_APPOINTMENT_ONCE_WE_GO_BACK_FROM_CUSTOMER_PROFILE,
    data: shouldWeSave
  };
};

export const getApiCustomerProfileData = customerId => {
  return {
    type: GET_CUSTOMER_PROFILE_DATA,
    customerId: customerId
  };
};

export const saveNewCustomerData = payload => {
  return {
    type: SAVE_NEW_CUSTOMER_DATA,
    payload: payload
  };
};

export const saveEditedCustomerData = (payload, customerId) => {
  return {
    type: SAVE_EDITED_CUSTOMER_DATA,
    payload: payload,
    customerId: customerId
  };
};

export const updateCustomerProfileData = data => {
  return {
    type: UPDATED_CUSTOMER_PROFILE_DATA,
    data: data
  };
};

export const updateBookingOnlyCustomerProfileData = data => {
  return {
    type: UPDATED_BOOKING_ONLY_CUSTOMER_PROFILE_DATA,
    data: data
  };
};

export const setIsLoadingOnCustomerProfile = isLoading => {
  return {
    type: SET_IS_LOADING_CUSTOMER_PROFILE,
    loadingCustomerProfile: isLoading
  };
};

export const resetCustomerProfileForm = () => {
  return {
    type: RESET_CUSTOMER_PROFILE_FORM
  };
};

export const updateCustomerNotYetSavedFlag = visible => {
  return {
    type: UPDATE_CUSTOMER_NOT_YET_SAVED_FLAG,
    data: visible
  };
};
